import { render, staticRenderFns } from "./QuickNav.vue?vue&type=template&id=6b91e382&scoped=true&"
import script from "./QuickNav.vue?vue&type=script&lang=ts&"
export * from "./QuickNav.vue?vue&type=script&lang=ts&"
import style0 from "./QuickNav.vue?vue&type=style&index=0&id=6b91e382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b91e382",
  null
  
)

export default component.exports